<script>
import { mapState, mapActions, mapMutations } from 'vuex';
import CKEditor from '@ckeditor/ckeditor5-vue';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import Question from './Question';

export default {
  name: 'ModuleExamsEdition',
  components: {
    CKEditor: CKEditor.component,
    Question,
  },
  data() {
    return {
      editor: ClassicEditor,
      editorConfig: {},
    };
  },
  computed: {
    ...mapState('exam/item', [
      'item',
    ]),
    title: {
      get () {
        return this.item.title;
      },
      set (value) {
        const { item } = this;
        item.title = value;
        this.setItem(item);
      },
    },
    description: {
      get () {
        return this.item.description || '';
      },
      set (value) {
        const { item } = this;
        item.description = value;
        this.setItem(item);
      },
    },
    covers: {
      get() {
        return this.item.covers || '';
      },
      set(value) {
        const { item } = this;
        item.covers = value;
        this.setItem(item);
      },
    },
    numberOfQuestions: {
      get () {
        return this.item.numberOfQuestions || '';
      },
      set (value) {
        const { item } = this;
        item.numberOfQuestions = parseInt(value);
        this.setItem(item);
      },
    },
    passRate: {
      get () {
        return this.item.passRate || '';
      },
      set (value) {
        const { item } = this;
        item.passRate = parseInt(value);
        this.setItem(item);
      },
    },
    template: {
      get () {
        return this.item.template || null;
      },
      set (value) {
        const { item } = this;
        item.template = value;
        this.setItem(item);
      },
    },
    templates() {
      return [
        {
          id: 'novartis',
          label: 'Novartis',
        },
        {
          id: 'ge-healthcare',
          label: 'GE Healthcare',
        },
        {
          id: 'takeda',
          label: 'Takeda',
        },
        {
          id: 'takeda_pno',
          label: 'Takeda PNO',
        },
        {
          id: 'takeda_nchzj',
          label: 'Takeda NChZJ',
        },
        {
          id: 'fundacja-w-trosce',
          label: 'Fundacja w Trosce',
        },
      ];
    },
  },
  methods: {
    ...mapActions('exam/item', [
      'save',
      'fetch',
    ]),
    ...mapMutations('exam/item', [
      'setItem',
      'reset',
      'addQuestion',
    ]),
    localSave() {
      this.save()
        .then(() => {

          this.$router.push({ name: 'exams-listing' });
        })
      ;
    },
  },
  created() {
    const { id } = this.$route.params;

    if (!id) {
      this.reset();
      return;
    }

    this.fetch(id);
  },
};
</script>
<template>
  <div>
    <div class="box">
      <h2>General</h2>
      <div class="form-group mt-3">
        <label for="title" class="d-block">Title</label>
        <input id="title" class="form-control rounded-0" v-model="title" />
      </div>
      <div class="form-group mt-3">
        <label for="description" class="d-block">Description</label>
        <CKEditor id="description" :editor="editor" v-model="description" :config="editorConfig" />
      </div>
      <div class="form-group mt-3">
        <label for="covers" class="d-block">Topics Covered by Course &amp; Exam</label>
        <CKEditor id="covers" :editor="editor" v-model="covers" :config="editorConfig" />
      </div>
      <div class="form-group mt-3">
        <label for="number-of-questions" class="d-block">Number Of Questions</label>
        <input id="number-of-questions" type="number" min="1" class="form-control rounded-0" v-model="numberOfQuestions" />
      </div>
      <div class="form-group mt-3">
        <label for="pass-rate" class="d-block">Pass Rate</label>
        <input id="pass-rate" type="number" min="0" max="100" class="form-control rounded-0" v-model="passRate" />
      </div>
      <div class="form-group mt-3">
        <label for="template" class="d-block">Certificate Template</label>
        <select id="template" class="form-control rounded-0" v-model="template">
          <option value="" disabled>Select a Certificate Template</option>
          <option v-for="item in templates" :key="item.id" :value="item.id">{{ item.label }}</option>
        </select>
      </div>
    </div>

    <question v-for="(question, index) in item.questions" :key="index" :order="index" :item="question" />

    <div class="box mt-3">
      <div class="d-flex justify-content-between">
        <button class="btn btn-danger" @click="addQuestion">Add Question</button>
        <button class="btn btn-primary" @click="localSave">Save</button>
      </div>
    </div>
  </div>
</template>
